/* ================================================
   BP Cart Count Updater
   Listens to Dawn's cart pubsub events and updates
   the BAG count bubble in real time whenever items
   are added or removed.
   ================================================ */

(function () {
  /* Dawn publishes cart updates via its pubsub system.
     The event name is defined in pubsub.js as
     PUB_SUB_EVENTS.cartUpdate — which resolves to 'cart-update'.
     We subscribe as soon as the DOM is ready. */

  function updateBagCount(count) {
    var bubble = document.querySelector('.bp-header__bag-count');
    if (!bubble) return;
    bubble.textContent = count;

    /* Optional: quick pop animation to confirm the update */
    bubble.classList.remove('bp-bag-pop');
    void bubble.offsetWidth; /* reflow to restart animation */
    bubble.classList.add('bp-bag-pop');
  }

  function attachSubscription() {
    /* subscribe() is defined in Dawn's pubsub.js which loads
       via defer — wait until it exists */
    if (typeof subscribe !== 'function') {
      setTimeout(attachSubscription, 50);
      return;
    }

    /* 'cart-update' fires after every add/remove/update */
    subscribe('cart-update', function (event) {
      var count =
        (event && event.cart && event.cart.item_count != null)
          ? event.cart.item_count
          : null;

      if (count !== null) {
        updateBagCount(count);
        return;
      }

      /* Fallback: fetch the cart JSON directly */
      fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { updateBagCount(cart.item_count); })
        .catch(function () {});
    });

    /* Also handle the cart-drawer 'CartDrawer:open' for good measure */
    subscribe('CartDrawer:open', function () {
      fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { updateBagCount(cart.item_count); })
        .catch(function () {});
    });
  }

  document.addEventListener('DOMContentLoaded', attachSubscription);

})();
